import Typography from '@mui/material/Typography'
import I18n from 'i18n-js'
import PropTypes from 'prop-types'
import { useState, useEffect, memo } from 'react'

import DropdownSelectList from '../../shared/DropdownSelectList'
import ChannelPageShimmer from '../PaidAdShimmers/ChannelPageShimmer'

import ChannelPageItem from './ChannelPageItem'

const ChannelPageSelector = ({
  facebookPages = [],
  isLoading,
  onFacebookPageSelect,
  selectedFacebookPageId,
}) => {
  const selectedFacebookPage = facebookPages.find(
    (page) => page.id === selectedFacebookPageId,
  )

  const [selectedPage, selectPage] = useState({
    value: selectedFacebookPageId || null,
    element: (
      <ChannelPageItem
        name={(selectedFacebookPage && selectedFacebookPage.name) || null}
        thumbnail={
          (selectedFacebookPage && selectedFacebookPage.picture_url) || null
        }
      />
    ),
  })

  useEffect(
    () =>
      selectPage({
        value: selectedFacebookPageId || null,
        element: (
          <ChannelPageItem
            {...selectedFacebookPage}
            thumbnail={
              (selectedFacebookPage && selectedFacebookPage.picture_url) || null
            }
          />
        ),
      }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [facebookPages, selectedFacebookPageId],
  )

  const dropdownItems = facebookPages.map((page) => {
    return {
      value: page.id,
      element: (
        <ChannelPageItem name={page.name} thumbnail={page.picture_url} />
      ),
    }
  })
  return (
    <div>
      {isLoading ? (
        <ChannelPageShimmer />
      ) : (
        <>
          <Typography variant="h6">
            {I18n.t('content.selectYourFacebookPage')}
          </Typography>
          {(facebookPages.length > 0 &&
            selectedFacebookPageId &&
            selectedPage.value && (
              <DropdownSelectList
                dropdownWidth={'full'}
                items={dropdownItems}
                onSelect={(pageId) => onFacebookPageSelect(pageId)}
                selectedItem={selectedPage}
                theme={'square'}
              />
            )) || (
            <Typography color="textSecondary" variant="body2">
              {I18n.t('content.beforeYouCanShare')}
            </Typography>
          )}
        </>
      )}
    </div>
  )
}

ChannelPageSelector.propTypes = {
  facebookPages: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      thumbnail: PropTypes.string,
    }),
  ),
  isLoading: PropTypes.bool,
  onFacebookPageSelect: PropTypes.func,
  selectedFacebookPageId: PropTypes.number,
}

ChannelPageSelector.defaultProps = {
  facebookPages: [],
  onSelect: () => {},
}

export default memo(ChannelPageSelector)
